"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CollapseSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28.64,14.07l-9.83.1a1.1,1.1,0,0,1-.79-.35,1,1,0,0,1-.34-.78l.09-9.86a1.08,1.08,0,0,1,1.07-1.07h0a1,1,0,0,1,1.05,1.05l-.08,7.48L28.62,1.8A1,1,0,1,1,30,3.21L21.21,12,28.66,12a1,1,0,0,1,1,1h0A1.07,1.07,0,0,1,28.64,14.07ZM2.3,19h0a1,1,0,0,0,1,1L10.79,20,2,28.79A1,1,0,0,0,3.38,30.2l8.81-8.84-.08,7.48a1,1,0,0,0,1.05,1.05h0a1.08,1.08,0,0,0,1.07-1.07L14.32,19a1,1,0,0,0-.34-.78,1.1,1.1,0,0,0-.79-.35l-9.83.1A1.07,1.07,0,0,0,2.3,19Z"/><path d="M2.67,31.5a2,2,0,0,1-1.41-3.42L8.35,21l-5,.05h0a2.05,2.05,0,0,1-1.44-.59A2,2,0,0,1,1.3,19h0a2.08,2.08,0,0,1,2.05-2.06l9.83-.1a2.21,2.21,0,0,1,1.51.64,2,2,0,0,1,.63,1.5l-.09,9.86a2.08,2.08,0,0,1-2.06,2.06,2,2,0,0,1-1.46-.6,2,2,0,0,1-.6-1.46l.05-5-7.07,7.1A2,2,0,0,1,2.67,31.5ZM13.21,19l-.1,9.89c.08,0,.12,0,.12,0L13.32,19c-.09-.11-.09-.11-.19-.12l-9.76.1A.08.08,0,0,0,3.3,19s0,0,0,0l9.9-.11v0h0Zm5.61-3.79a2.21,2.21,0,0,1-1.51-.64,2,2,0,0,1-.63-1.5l.09-9.86a2.06,2.06,0,0,1,3.52-1.46,2,2,0,0,1,.6,1.46l-.05,5,7.07-7.1A2,2,0,0,1,29.32.5h0a2,2,0,0,1,1.41.59,2,2,0,0,1,.58,1.41,2,2,0,0,1-.58,1.42L23.65,11l5,0h0a2.06,2.06,0,0,1,1.45.59A2,2,0,0,1,30.7,13a2.08,2.08,0,0,1-2.05,2.06Zm0-12a.06.06,0,0,0-.06.06l-.09,9.86c.09.11.09.11.19.12l9.76-.1A.08.08,0,0,0,28.7,13l-9.92.08,0-2.46.08-7.47Z"/>';
var CollapseSVG = function CollapseSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CollapseSVG = CollapseSVG;
CollapseSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CollapseSVG);
exports.default = _default;